// extracted by mini-css-extract-plugin
export default {"info":"FilterInfo_info__4iytA","container":"FilterInfo_container__iSnH0","boldText":"FilterInfo_boldText__CjvO5","children":"FilterInfo_children__Ha9Fg"};